import React from 'react';
import PropTypes from 'prop-types';

/** An inline svg component. */
const Discover = ({
  size = 16,
  height = 20,
  width = 32,
  svgRef,
  title,
  style = {},
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 32 20"
      height={height || size}
      width={width || size}
      ref={svgRef}
      aria-labelledby={title ? title : undefined}
      style={{ pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      {title ? <title id={title}>{title}</title> : null}
      <g clip-path="url(#clip0_677_11243)">
        <path
          d="M0 19.0196V0.980392C0 0.439216 0.439216 0 0.980392 0H30.3922C30.9333 0 31.3726 0.439216 31.3726 0.980392V19.0196C31.3726 19.5608 30.9333 20 30.3922 20H0.980392C0.439216 20 0 19.5608 0 19.0196Z"
          fill="url(#paint0_linear_677_11243)"
        />
        <path
          d="M0.392578 0.972604C0.392578 0.651035 0.651402 0.392212 0.97297 0.392212H20.1965C25.5063 0.392212 29.8043 4.69025 29.8043 10.0001C29.8043 15.3099 25.5063 19.6079 20.1965 19.6079H0.97297C0.651402 19.6079 0.392578 19.3491 0.392578 19.0275V0.972604Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.8906 9.81171H25.6475V8.51759H25.9063C26.424 8.51759 26.6985 8.7372 26.6985 9.14504C26.6985 9.57641 26.4161 9.80386 25.8906 9.80386V9.81171ZM27.5612 9.10583C27.5612 8.31367 27.0122 7.84308 26.0553 7.84308H24.824V12.1019H25.6553V10.3843H25.7651L26.9102 12.1019H27.9298L26.5887 10.3058C27.224 10.1725 27.5691 9.74896 27.5691 9.09798M21.922 12.1097H24.2749V11.3803H22.7455V10.2352H24.22V9.50583H22.7455V8.56465H24.2749V7.83524H21.922V12.0941V12.1097ZM19.4906 10.7137L18.3612 7.85092H17.4436L19.2475 12.2196H19.6946L21.5377 7.85092H20.6357L19.4906 10.7137ZM9.62397 9.98426C9.62397 11.2313 10.6044 12.2039 11.8749 12.2039C12.2357 12.2039 12.5338 12.1333 12.9102 11.9607V10.9803C12.5808 11.3097 12.2906 11.4431 11.9142 11.4431C11.0828 11.4431 10.4867 10.8392 10.4867 9.96857C10.4867 9.15288 11.0985 8.5019 11.8749 8.5019C12.2749 8.5019 12.5808 8.64308 12.9102 8.97249V7.9921C12.5416 7.81171 12.2514 7.73328 11.8906 7.73328C10.6279 7.73328 9.62397 8.72151 9.62397 9.96857M8.12593 9.4823C7.62397 9.3019 7.48279 9.17641 7.48279 8.94112C7.48279 8.6823 7.74161 8.47053 8.1024 8.47053C8.34553 8.47053 8.54946 8.58034 8.76906 8.81563L9.20044 8.25092C8.84749 7.9372 8.41612 7.78034 7.95338 7.78034C7.20044 7.78034 6.62789 8.30583 6.62789 9.00386C6.62789 9.5921 6.88671 9.89798 7.67103 10.1725C8.00044 10.2901 8.16514 10.3607 8.25142 10.4156C8.41612 10.5333 8.49455 10.6745 8.49455 10.8548C8.49455 11.1999 8.22789 11.4509 7.85142 11.4509C7.45142 11.4509 7.13769 11.2548 6.94161 10.8862L6.40044 11.4039C6.78475 11.9607 7.23965 12.2117 7.87495 12.2117C8.73769 12.2117 9.34946 11.6313 9.34946 10.8156C9.34946 10.1254 9.07495 9.81955 8.12593 9.47445M5.27887 12.1097H6.11024V7.85092H5.27887V12.1097ZM3.56906 11.0509C3.31024 11.2862 2.97299 11.396 2.43181 11.396H2.2122V8.58034H2.43181C2.97299 8.58034 3.28671 8.6823 3.56906 8.92543C3.85142 9.18426 4.02397 9.57641 4.02397 9.98426C4.02397 10.3921 3.85142 10.7921 3.56906 11.0431V11.0509ZM2.60436 7.85092H1.38867V12.1097H2.59652C3.23181 12.1097 3.71024 11.9529 4.11808 11.6156C4.59652 11.2078 4.88671 10.6117 4.88671 9.98426C4.88671 8.7372 3.95338 7.85092 2.60436 7.85092ZM27.7887 8.07837C27.7887 7.98426 27.82 7.89798 27.8828 7.83524C27.9455 7.77249 28.024 7.73328 28.1181 7.73328C28.2122 7.73328 28.2906 7.76465 28.3534 7.83524C28.4161 7.90583 28.4475 7.98426 28.4475 8.07837C28.4475 8.17249 28.4161 8.25877 28.3534 8.32151C28.2906 8.38426 28.2122 8.42347 28.1181 8.42347C28.024 8.42347 27.9455 8.3921 27.8828 8.32151C27.82 8.25877 27.7887 8.18034 27.7887 8.07837ZM27.8593 8.07837C27.8593 8.15681 27.8828 8.22739 27.9377 8.27445C27.9847 8.32936 28.0475 8.35288 28.1259 8.35288C28.2044 8.35288 28.2671 8.32936 28.3142 8.27445C28.3612 8.22739 28.3847 8.15681 28.3847 8.07837C28.3847 7.99994 28.3612 7.92936 28.3142 7.8823C28.2671 7.83524 28.2044 7.80386 28.1259 7.80386C28.0475 7.80386 27.9847 7.82739 27.9377 7.8823C27.8906 7.92936 27.8671 7.99994 27.8593 8.07837ZM27.9926 7.86661H28.1416C28.2279 7.86661 28.2749 7.90583 28.2749 7.98426C28.2749 8.02347 28.2671 8.05485 28.2436 8.07053C28.2279 8.08622 28.2044 8.1019 28.173 8.1019L28.2828 8.26661H28.2044L28.0946 8.1019H28.0553V8.26661H27.9926V7.86661ZM28.0632 8.047H28.1102C28.1102 8.047 28.1651 8.047 28.1808 8.03916C28.2044 8.03916 28.2122 8.01563 28.2122 7.9921C28.2122 7.96857 28.2044 7.95288 28.1887 7.94504C28.173 7.94504 28.1495 7.9372 28.1259 7.9372H28.0632V8.047Z"
          fill="#251E1F"
        />
        <g filter="url(#filter0_i_677_11243)">
          <path
            d="M15.4587 7.6784C16.7607 7.69408 17.796 8.76075 17.7803 10.0627C17.7646 11.3647 16.6979 12.4 15.396 12.3843C14.094 12.3686 13.0587 11.3019 13.0744 9.99997C13.0901 8.69801 14.1567 7.66271 15.4587 7.6784Z"
            fill="url(#paint1_linear_677_11243)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_677_11243"
          x="13.0742"
          y="7.67822"
          width="4.95605"
          height="5.2063"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.25" dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.568627 0 0 0 0 0.105882 0 0 0 0 0 0 0 0 0.75 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_677_11243"
          />
        </filter>
        <linearGradient
          id="paint0_linear_677_11243"
          x1="15.6863"
          y1="0"
          x2="22.2924"
          y2="17.048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E35416" />
          <stop offset="1" stop-color="#F7971F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_677_11243"
          x1="14.0369"
          y1="8.10606"
          x2="16.8178"
          y2="11.9566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF3700" />
          <stop offset="1" stop-color="#FF9200" />
        </linearGradient>
        <clipPath id="clip0_677_11243">
          <rect width="31.3726" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

Discover.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { Discover };
